<!--Modal: Login / Register Form-->
<div mdbModal #notificationsModal="mdb-modal" class="modal fade modal-overflow" id="modalLRForm" tabindex="-1"
     role="dialog"
     aria-labelledby="myModalLabel" aria-hidden="true" (onShow)="loadNotifications()">
  <div class="modal-dialog cascading-modal" role="document">
    <!--Content-->
    <div class="modal-content">
      <!--Header-->
      <div class="modal-header modal-head">
        <h5 class="modal-title w-100"><i class="fa fa-list-alt"></i> Notificaciones.</h5>
        <button type="button" class="close waves-effect waves-light" data-dismiss="modal" aria-label="Close"
                (click)="notificationsModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <!--Body-->
      <div class="modal-body mb-0">
        <perfect-scrollbar style="max-height: 450px">
          <ul class="list-group">
            <li class="list-group-item text-muted px-2 py-1 cursor-pointer" *ngFor="let notification of notifications"
                (click)="seenNotification(notification, true)"
                (blur)="seenNotification(notification)">
              <small class="float-right"><strong>{{notification?.fecha_creacion?.$date | date: 'medium' }}</strong>
              </small>
              <div class="clearfix"></div>
              <small>{{notification.detalle}}</small>
            </li>
            <li class="list-group-item text-muted text-center" *ngIf="notifications?.length == 0">
              <small>Sin notificaciones por el momento.</small>
            </li>
          </ul>
        </perfect-scrollbar>
      </div>
      <!--/.Content-->
    </div>
  </div>
  <!--Modal: Login / Register Form-->
</div>
